import { cn } from "@/lib/utils";
import {
    IconAdjustmentsBolt,
    IconCloud,
    IconCurrencyDollar,
    IconEaseInOut,
    IconHeart,
    IconHelp,
    IconRouteAltLeft,
    IconTerminal2,
} from "@tabler/icons-react";
import AnimationContainer from "../utils/animation-container";

export function FeaturesGridSection() {
    const features = [
        {
            title: "بهترین قیمت بازار",
            description: "ما همیشه سعی می‌کنیم قیمت‌های رقابتی و منصفانه ارائه دهیم.",
            icon: <IconCurrencyDollar size={34} stroke={1.5} />,
        },
        {
            title: "پشتیبانی ۲۴/۷",
            description: "تیم پشتیبانی ما همیشه آماده کمک به شماست.",
            icon: <IconHelp size={34} stroke={1.5} />,
        },
        {
            title: "تحویل آنی",
            description: "تمام سفارشات شما در سریع‌ترین زمان ممکن پردازش و ارسال می‌شوند.",
            icon: <IconCloud size={34} stroke={1.5} />,
        },
        {
            title: "تنوع بالای محصولات",
            description: "از گیفت کارت‌ها گرفته تا ارزهای درون‌برنامه‌ای، همه را اینجا پیدا کنید.",
            icon: <IconRouteAltLeft size={34} stroke={1.5} />,
        },
        {
            title: "رشد سریع در بازی",
            description: "با آیتم‌های حرفه‌ای سریع‌تر در بازی‌های محبوب خود پیشرفت کنید.",
            icon: <IconTerminal2 size={34} stroke={1.5} />,
        },
        {
            title: "تخفیف‌های ویژه",
            description: "با خرید بیشتر، از تخفیف‌ها و پیشنهادات ویژه بهره‌مند شوید.",
            icon: <IconAdjustmentsBolt size={34} stroke={1.5} />,
        },
        {
            title: "امنیت خرید",
            description: "تمام تراکنش‌ها با امنیت بالا و روش‌های پرداخت مطمئن انجام می‌شود.",
            icon: <IconEaseInOut size={34} stroke={1.5} />,
        },
        {
            title: "محبوب در بین گیمرها",
            description: "بازیتور انتخاب اول هزاران گیمر ایرانی برای خرید آیتم‌های بازی است.",
            icon: <IconHeart size={34} stroke={1.5} />,
        },
    ];

    return (
        <AnimationContainer delay={0.5}>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative z-10 py-10 w-full mx-auto gap-6">
                {features.map((feature, index) => (
                    <Feature key={feature.title} {...feature} index={index} />
                ))}
            </div>
        </AnimationContainer>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
}: {
    title: string;
    description: string;
    icon: React.ReactNode;
    index: number;
}) => {
    return (
        <div
            className={cn(
                "relative group/feature flex flex-col py-10 px-6 rounded-xl border border-[#66269a91] shadow-lg transition-transform duration-300 hover:scale-105",
                "bg-[rgba(0,0,0,0.08)]"
            )}
        >
            <div className="absolute inset-0 bg-[#02010462] rounded-xl"></div>

            <div className="mb-4 relative z-10 text-purple-400">{icon}</div>

            <div className="text-lg font-semibold mb-2 relative z-10 text-white">
                {/* <div className="absolute left-0 inset-y-0 h-6 w-1 bg-purple-600 group-hover/feature:h-8 transition-all duration-200 rounded-tr-full rounded-br-full"></div> */}
                <span className="ml-3 group-hover/feature:translate-x-1 transition duration-200">
                    {title}
                </span>
            </div>

            {/* توضیحات */}
            <p className="text-sm text-gray-300">{description}</p>
        </div>
    );
};
